// components/OrderActions.jsx
import React, { useCallback, useState } from "react";
import {
  Link,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { BiUserX, BiUserCheck, BiShow } from "react-icons/bi";
import { useDispatch } from "react-redux";
import { CUSTOMER_STATUS_CHANGE } from "../../../actions/admin/customer-actions";
// import { RiRotateLockLine } from "react-icons/ri";
// import { FaFileSignature } from "react-icons/fa6";
export default function OrderActions({
  id,
  status,
  customerDetails,
  statusActionType = CUSTOMER_STATUS_CHANGE,
  detailLinkPrefix = "",
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const dispatch = useDispatch();

  const changeCustomeStatus = useCallback((data) => {
    dispatch({ type: statusActionType, payload : {
      ...data,
      onSuccess : () => {
        customerDetails();
        handleClose();
      }
    }});
  }, [dispatch, customerDetails, statusActionType]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Link
        component="button"
        underline="none"
        color="primary"
        onClick={handleClick}
      >
        VIEW
      </Link>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 3,
          sx: {
            minWidth: 200,
            borderRadius: 2,
            mt: 1,
          },
        }}
      >
        {detailLinkPrefix && (
          <MenuItem
            component={RouterLink}
            to={`${detailLinkPrefix}/${id}`}
            onClick={handleClose}
          >
            <ListItemIcon>
              <BiShow size={20} />
            </ListItemIcon>
            <ListItemText primary="View Details" />
          </MenuItem>
        )}
        <MenuItem onClick={()=>{
          changeCustomeStatus({
            id,
            is_suspended : !status
          })
        }}>
          <ListItemIcon>
            {status? <BiUserCheck size={20} color="error" /> : <BiUserX size={20} color="error" />}
            
          </ListItemIcon>
          <ListItemText primary={ status? "Active User" : "Suspend User" } />
        </MenuItem>

        {/* <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <RiRotateLockLine size={20} color="secondary" />
          </ListItemIcon>
          <ListItemText primary="Reset Password" />
        </MenuItem> */}
      </Menu>
    </>
  );
}
